import { SelectInputData } from "@src/components/deprecated/SelectInputField/SelectInputField";
import { t } from "i18next";
import { DataObjectFieldComparator } from "../../DataObjects/DataObjectFieldComparator";
import { DataObjectType } from "../../DataObjects/DataObjectHelper";
import { FirebaseDataSelectField, FirebaseDataSelectFieldOption } from "./FirebaseDataSelectField";

export class FirebaseDataBooleanField<FirebaseDataType extends DataObjectType> extends FirebaseDataSelectField<boolean, FirebaseDataType> {
  override convertValueToSelectInput(value: boolean): SelectInputData {
    return new SelectInputData(value + "", value ? t("main.yes") : t("main.no"));
  }
  getValueForKey(key: string): boolean | undefined {
    return key === "true";
  }
  getOptions(): FirebaseDataSelectFieldOption[] {
    return [
      { key: "true", label: t("main.yes") },
      { key: "false", label: t("main.no") },
    ];
  }

  override encode = (value: boolean) => value;
  decodeStringAsRawValue = () => true;

  getReadableStringRepresentation(value: boolean): string {
    return value ? t("main.yes") : t("main.no");
  }
  allComparators: DataObjectFieldComparator[] = ["equals", "not-equals", "is-known", "is-unknown"];

  override isValueValid = (value: any): boolean => {
    return typeof value === "boolean";
  };
}

